import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);

const parallax = () => {
	const parallaxItems = document.querySelectorAll('.c-parallax-el');

	parallaxItems.forEach((el) => {
		yEndPercentage = el.parentElement.hasAttribute('data-parallax-endY')
			? el.parentElement.getAttribute('data-parallax-endY')
			: '-15%';

		const tl = gsap.timeline({
			scrollTrigger: {
				trigger: el.parentNode,
				start: 'top bottom',
				end: 'bottom top',
				scrub: true,
			},
		});

		tl.to(el, { y: `${yEndPercentage}` });
	});
};

parallax();
